export default __webpack_public_path__ + "static/media/voucher2000.a5c8b7e72e196833d6a3e32a059e521a.png";